<template>
  <DefaultMultiField
    :value="value"
    :document-value="documentValue"
    :question="question"
    :questions="question.config.fields"
  />
</template>

<script>
import DefaultMultiField from './DefaultMultiField'

export default {
  components: { DefaultMultiField },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
    documentValue: {
      type: Object,
      required: true,
    },
  },
}
</script>
